// generated from 668 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const segmentComCohortFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("segment_com_cohort_filter"),
  comparison_key: z.enum([
    "7", // 464 (69.46%)
    "8", // 204 (30.54%)
  ]),
  display_name: z.string(),
  // undefined: 412 (61.68%), defined 256 (38.32%)
  raw_value: z.string().optional(),
  value: z.object({
    id: z.string(),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
